// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file tracker/v1/tag_manager.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Condition } from "./rule_pb.js";
import { Ownership, Pagination, PaginationMeta, ResourceKind, TagRef } from "./common_pb.js";

/**
 * @generated from enum tracker.v1.TagManagerSnippetKind
 */
export enum TagManagerSnippetKind {
  /**
   * @generated from enum value: TAG_MANAGER_SNIPPET_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TAG_MANAGER_SNIPPET_KIND_GTM = 1;
   */
  GTM = 1,

  /**
   * @generated from enum value: TAG_MANAGER_SNIPPET_KIND_PIXEL = 2;
   */
  PIXEL = 2,

  /**
   * @generated from enum value: TAG_MANAGER_SNIPPET_KIND_POSTBACK = 3;
   */
  POSTBACK = 3,

  /**
   * @generated from enum value: TAG_MANAGER_SNIPPET_KIND_CUSTOM_JS = 4;
   */
  CUSTOM_JS = 4,

  /**
   * @generated from enum value: TAG_MANAGER_SNIPPET_KIND_CUSTOM_HTML = 5;
   */
  CUSTOM_HTML = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(TagManagerSnippetKind)
proto3.util.setEnumType(TagManagerSnippetKind, "tracker.v1.TagManagerSnippetKind", [
  { no: 0, name: "TAG_MANAGER_SNIPPET_KIND_UNSPECIFIED" },
  { no: 1, name: "TAG_MANAGER_SNIPPET_KIND_GTM" },
  { no: 2, name: "TAG_MANAGER_SNIPPET_KIND_PIXEL" },
  { no: 3, name: "TAG_MANAGER_SNIPPET_KIND_POSTBACK" },
  { no: 4, name: "TAG_MANAGER_SNIPPET_KIND_CUSTOM_JS" },
  { no: 5, name: "TAG_MANAGER_SNIPPET_KIND_CUSTOM_HTML" },
]);

/**
 * @generated from enum tracker.v1.TagManagerPlacement
 */
export enum TagManagerPlacement {
  /**
   * @generated from enum value: TAG_MANAGER_PLACEMENT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TAG_MANAGER_PLACEMENT_HEAD = 1;
   */
  HEAD = 1,

  /**
   * @generated from enum value: TAG_MANAGER_PLACEMENT_BODY_TOP = 2;
   */
  BODY_TOP = 2,

  /**
   * @generated from enum value: TAG_MANAGER_PLACEMENT_BODY_BOTTOM = 3;
   */
  BODY_BOTTOM = 3,

  /**
   * @generated from enum value: TAG_MANAGER_PLACEMENT_BEFORE_REDIRECT = 4;
   */
  BEFORE_REDIRECT = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(TagManagerPlacement)
proto3.util.setEnumType(TagManagerPlacement, "tracker.v1.TagManagerPlacement", [
  { no: 0, name: "TAG_MANAGER_PLACEMENT_UNSPECIFIED" },
  { no: 1, name: "TAG_MANAGER_PLACEMENT_HEAD" },
  { no: 2, name: "TAG_MANAGER_PLACEMENT_BODY_TOP" },
  { no: 3, name: "TAG_MANAGER_PLACEMENT_BODY_BOTTOM" },
  { no: 4, name: "TAG_MANAGER_PLACEMENT_BEFORE_REDIRECT" },
]);

/**
 * @generated from enum tracker.v1.TagManagerSnippetStatus
 */
export enum TagManagerSnippetStatus {
  /**
   * @generated from enum value: TAG_MANAGER_SNIPPET_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TAG_MANAGER_SNIPPET_STATUS_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * @generated from enum value: TAG_MANAGER_SNIPPET_STATUS_PUBLISHED = 2;
   */
  PUBLISHED = 2,

  /**
   * @generated from enum value: TAG_MANAGER_SNIPPET_STATUS_ARCHIVED = 3;
   */
  ARCHIVED = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(TagManagerSnippetStatus)
proto3.util.setEnumType(TagManagerSnippetStatus, "tracker.v1.TagManagerSnippetStatus", [
  { no: 0, name: "TAG_MANAGER_SNIPPET_STATUS_UNSPECIFIED" },
  { no: 1, name: "TAG_MANAGER_SNIPPET_STATUS_DRAFT" },
  { no: 2, name: "TAG_MANAGER_SNIPPET_STATUS_PUBLISHED" },
  { no: 3, name: "TAG_MANAGER_SNIPPET_STATUS_ARCHIVED" },
]);

/**
 * TagManagerDestination identifies the server-side adapter that POSTBACK kind
 * snippets dispatch through. CUSTOM_HTTP is the default — the snippet's
 * `code` field carries the raw URL.
 *
 * There is deliberately no Meta destination: vibe-fb is the single sender
 * for Meta CAPI (`POST /api/v1/capi/events`, `event_id = click_id`). The
 * tracker's job is to carry `{pixel}` on the click and `_fbc`/`_fbp` on the
 * lander.
 *
 * @generated from enum tracker.v1.TagManagerDestination
 */
export enum TagManagerDestination {
  /**
   * @generated from enum value: TAG_MANAGER_DESTINATION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TAG_MANAGER_DESTINATION_CUSTOM_HTTP = 1;
   */
  CUSTOM_HTTP = 1,

  /**
   * @generated from enum value: TAG_MANAGER_DESTINATION_GA4_MP = 2;
   */
  GA4_MP = 2,

  /**
   * @generated from enum value: TAG_MANAGER_DESTINATION_TIKTOK_EVENTS = 4;
   */
  TIKTOK_EVENTS = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(TagManagerDestination)
proto3.util.setEnumType(TagManagerDestination, "tracker.v1.TagManagerDestination", [
  { no: 0, name: "TAG_MANAGER_DESTINATION_UNSPECIFIED" },
  { no: 1, name: "TAG_MANAGER_DESTINATION_CUSTOM_HTTP" },
  { no: 2, name: "TAG_MANAGER_DESTINATION_GA4_MP" },
  { no: 4, name: "TAG_MANAGER_DESTINATION_TIKTOK_EVENTS" },
]);

/**
 * TagManagerSnippet is a piece of code (GTM, pixel, postback, custom) injected
 * at a specific placement on landers, traffic-source pages, or before-redirect.
 * `conditions` reuses the unified rule Condition tree so a snippet can fire
 * only on, say, country=US AND device=mobile.
 *
 * @generated from message tracker.v1.TagManagerSnippet
 */
export class TagManagerSnippet extends Message<TagManagerSnippet> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: tracker.v1.TagManagerSnippetKind kind = 4;
   */
  kind = TagManagerSnippetKind.UNSPECIFIED;

  /**
   * @generated from field: tracker.v1.TagManagerScope scope = 5;
   */
  scope?: TagManagerScope;

  /**
   * @generated from field: tracker.v1.TagManagerPlacement placement = 6;
   */
  placement = TagManagerPlacement.UNSPECIFIED;

  /**
   * @generated from field: string code = 7;
   */
  code = "";

  /**
   * @generated from field: tracker.v1.Condition conditions = 8;
   */
  conditions?: Condition;

  /**
   * @generated from field: bool enabled = 9;
   */
  enabled = false;

  /**
   * @generated from field: repeated tracker.v1.TagRef tags = 10;
   */
  tags: TagRef[] = [];

  /**
   * @generated from field: tracker.v1.Ownership ownership = 11;
   */
  ownership?: Ownership;

  /**
   * @generated from field: string created_at = 12;
   */
  createdAt = "";

  /**
   * @generated from field: string updated_at = 13;
   */
  updatedAt = "";

  /**
   * M3 versioning + Consent Mode v2.
   *
   * @generated from field: tracker.v1.TagManagerSnippetStatus status = 14;
   */
  status = TagManagerSnippetStatus.UNSPECIFIED;

  /**
   * @generated from field: int32 version = 15;
   */
  version = 0;

  /**
   * @generated from field: string published_at = 16;
   */
  publishedAt = "";

  /**
   * @generated from field: string published_by = 17;
   */
  publishedBy = "";

  /**
   * Consent Mode v2 categories that must be granted in the visitor's
   * consent state before the engine fires this snippet. Empty array
   * disables the gate.
   *
   * @generated from field: repeated string consent_required = 18;
   */
  consentRequired: string[] = [];

  /**
   * M4 destination adapters.
   *
   * @generated from field: tracker.v1.TagManagerDestination destination = 19;
   */
  destination = TagManagerDestination.UNSPECIFIED;

  /**
   * @generated from field: tracker.v1.TagManagerDestinationConfig destination_config = 20;
   */
  destinationConfig?: TagManagerDestinationConfig;

  /**
   * field_mappings is a JSON-encoded
   *   [{"destination_field": "...", "source_macro": "{{click.country}}"}, ...]
   * It is opaque to the proto so consumers can iterate freely as the
   * destination registry grows; the BE validates shape at write time.
   *
   * @generated from field: string field_mappings_json = 21;
   */
  fieldMappingsJson = "";

  constructor(data?: PartialMessage<TagManagerSnippet>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.TagManagerSnippet";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "kind", kind: "enum", T: proto3.getEnumType(TagManagerSnippetKind) },
    { no: 5, name: "scope", kind: "message", T: TagManagerScope },
    { no: 6, name: "placement", kind: "enum", T: proto3.getEnumType(TagManagerPlacement) },
    { no: 7, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "conditions", kind: "message", T: Condition },
    { no: 9, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "tags", kind: "message", T: TagRef, repeated: true },
    { no: 11, name: "ownership", kind: "message", T: Ownership },
    { no: 12, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "status", kind: "enum", T: proto3.getEnumType(TagManagerSnippetStatus) },
    { no: 15, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "published_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "published_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "consent_required", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 19, name: "destination", kind: "enum", T: proto3.getEnumType(TagManagerDestination) },
    { no: 20, name: "destination_config", kind: "message", T: TagManagerDestinationConfig },
    { no: 21, name: "field_mappings_json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TagManagerSnippet {
    return new TagManagerSnippet().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TagManagerSnippet {
    return new TagManagerSnippet().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TagManagerSnippet {
    return new TagManagerSnippet().fromJsonString(jsonString, options);
  }

  static equals(a: TagManagerSnippet | PlainMessage<TagManagerSnippet> | undefined, b: TagManagerSnippet | PlainMessage<TagManagerSnippet> | undefined): boolean {
    return proto3.util.equals(TagManagerSnippet, a, b);
  }
}

/**
 * @generated from message tracker.v1.TagManagerScope
 */
export class TagManagerScope extends Message<TagManagerScope> {
  /**
   * RESOURCE_KIND_LANDER / RESOURCE_KIND_TRAFFIC_SOURCE / RESOURCE_KIND_WORKSPACE
   *
   * @generated from field: tracker.v1.ResourceKind kind = 1;
   */
  kind = ResourceKind.UNSPECIFIED;

  /**
   * @generated from field: string resource_id = 2;
   */
  resourceId = "";

  constructor(data?: PartialMessage<TagManagerScope>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.TagManagerScope";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "kind", kind: "enum", T: proto3.getEnumType(ResourceKind) },
    { no: 2, name: "resource_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TagManagerScope {
    return new TagManagerScope().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TagManagerScope {
    return new TagManagerScope().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TagManagerScope {
    return new TagManagerScope().fromJsonString(jsonString, options);
  }

  static equals(a: TagManagerScope | PlainMessage<TagManagerScope> | undefined, b: TagManagerScope | PlainMessage<TagManagerScope> | undefined): boolean {
    return proto3.util.equals(TagManagerScope, a, b);
  }
}

/**
 * TagManagerDestinationConfig is the adapter-specific configuration. The
 * oneof is sparse — only the matching nested message is populated for a
 * given Destination value.
 *
 * @generated from message tracker.v1.TagManagerDestinationConfig
 */
export class TagManagerDestinationConfig extends Message<TagManagerDestinationConfig> {
  /**
   * @generated from oneof tracker.v1.TagManagerDestinationConfig.config
   */
  config: {
    /**
     * @generated from field: tracker.v1.Ga4MpConfig ga4_mp = 1;
     */
    value: Ga4MpConfig;
    case: "ga4Mp";
  } | {
    /**
     * @generated from field: tracker.v1.TiktokEventsConfig tiktok_events = 3;
     */
    value: TiktokEventsConfig;
    case: "tiktokEvents";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<TagManagerDestinationConfig>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.TagManagerDestinationConfig";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ga4_mp", kind: "message", T: Ga4MpConfig, oneof: "config" },
    { no: 3, name: "tiktok_events", kind: "message", T: TiktokEventsConfig, oneof: "config" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TagManagerDestinationConfig {
    return new TagManagerDestinationConfig().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TagManagerDestinationConfig {
    return new TagManagerDestinationConfig().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TagManagerDestinationConfig {
    return new TagManagerDestinationConfig().fromJsonString(jsonString, options);
  }

  static equals(a: TagManagerDestinationConfig | PlainMessage<TagManagerDestinationConfig> | undefined, b: TagManagerDestinationConfig | PlainMessage<TagManagerDestinationConfig> | undefined): boolean {
    return proto3.util.equals(TagManagerDestinationConfig, a, b);
  }
}

/**
 * @generated from message tracker.v1.Ga4MpConfig
 */
export class Ga4MpConfig extends Message<Ga4MpConfig> {
  /**
   * @generated from field: string measurement_id = 1;
   */
  measurementId = "";

  /**
   * api_secret_ref is an AWS Secrets Manager key (e.g.
   * "vibe/prod/vibe-tracker/destinations/<id>"). The BE never accepts a
   * raw secret over the wire; the FE renders it as a free-text input.
   *
   * @generated from field: string api_secret_ref = 2;
   */
  apiSecretRef = "";

  /**
   * @generated from field: string event_name = 3;
   */
  eventName = "";

  constructor(data?: PartialMessage<Ga4MpConfig>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.Ga4MpConfig";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "measurement_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "api_secret_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Ga4MpConfig {
    return new Ga4MpConfig().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Ga4MpConfig {
    return new Ga4MpConfig().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Ga4MpConfig {
    return new Ga4MpConfig().fromJsonString(jsonString, options);
  }

  static equals(a: Ga4MpConfig | PlainMessage<Ga4MpConfig> | undefined, b: Ga4MpConfig | PlainMessage<Ga4MpConfig> | undefined): boolean {
    return proto3.util.equals(Ga4MpConfig, a, b);
  }
}

/**
 * @generated from message tracker.v1.TiktokEventsConfig
 */
export class TiktokEventsConfig extends Message<TiktokEventsConfig> {
  /**
   * @generated from field: string pixel_id = 1;
   */
  pixelId = "";

  /**
   * @generated from field: string access_token_ref = 2;
   */
  accessTokenRef = "";

  /**
   * @generated from field: string event_name = 3;
   */
  eventName = "";

  constructor(data?: PartialMessage<TiktokEventsConfig>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.TiktokEventsConfig";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pixel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "access_token_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TiktokEventsConfig {
    return new TiktokEventsConfig().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TiktokEventsConfig {
    return new TiktokEventsConfig().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TiktokEventsConfig {
    return new TiktokEventsConfig().fromJsonString(jsonString, options);
  }

  static equals(a: TiktokEventsConfig | PlainMessage<TiktokEventsConfig> | undefined, b: TiktokEventsConfig | PlainMessage<TiktokEventsConfig> | undefined): boolean {
    return proto3.util.equals(TiktokEventsConfig, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListSnippetsRequest
 */
export class ListSnippetsRequest extends Message<ListSnippetsRequest> {
  /**
   * @generated from field: tracker.v1.Pagination pagination = 1;
   */
  pagination?: Pagination;

  /**
   * @generated from field: tracker.v1.TagManagerScope scope = 2;
   */
  scope?: TagManagerScope;

  /**
   * @generated from field: bool enabled_only = 3;
   */
  enabledOnly = false;

  constructor(data?: PartialMessage<ListSnippetsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListSnippetsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: Pagination },
    { no: 2, name: "scope", kind: "message", T: TagManagerScope },
    { no: 3, name: "enabled_only", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSnippetsRequest {
    return new ListSnippetsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSnippetsRequest {
    return new ListSnippetsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSnippetsRequest {
    return new ListSnippetsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListSnippetsRequest | PlainMessage<ListSnippetsRequest> | undefined, b: ListSnippetsRequest | PlainMessage<ListSnippetsRequest> | undefined): boolean {
    return proto3.util.equals(ListSnippetsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListSnippetsResponse
 */
export class ListSnippetsResponse extends Message<ListSnippetsResponse> {
  /**
   * @generated from field: repeated tracker.v1.TagManagerSnippet items = 1;
   */
  items: TagManagerSnippet[] = [];

  /**
   * @generated from field: tracker.v1.PaginationMeta pagination = 2;
   */
  pagination?: PaginationMeta;

  constructor(data?: PartialMessage<ListSnippetsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListSnippetsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: TagManagerSnippet, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationMeta },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSnippetsResponse {
    return new ListSnippetsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSnippetsResponse {
    return new ListSnippetsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSnippetsResponse {
    return new ListSnippetsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListSnippetsResponse | PlainMessage<ListSnippetsResponse> | undefined, b: ListSnippetsResponse | PlainMessage<ListSnippetsResponse> | undefined): boolean {
    return proto3.util.equals(ListSnippetsResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetSnippetRequest
 */
export class GetSnippetRequest extends Message<GetSnippetRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetSnippetRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetSnippetRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSnippetRequest {
    return new GetSnippetRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSnippetRequest {
    return new GetSnippetRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSnippetRequest {
    return new GetSnippetRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSnippetRequest | PlainMessage<GetSnippetRequest> | undefined, b: GetSnippetRequest | PlainMessage<GetSnippetRequest> | undefined): boolean {
    return proto3.util.equals(GetSnippetRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetSnippetResponse
 */
export class GetSnippetResponse extends Message<GetSnippetResponse> {
  /**
   * @generated from field: tracker.v1.TagManagerSnippet snippet = 1;
   */
  snippet?: TagManagerSnippet;

  constructor(data?: PartialMessage<GetSnippetResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetSnippetResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "snippet", kind: "message", T: TagManagerSnippet },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSnippetResponse {
    return new GetSnippetResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSnippetResponse {
    return new GetSnippetResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSnippetResponse {
    return new GetSnippetResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSnippetResponse | PlainMessage<GetSnippetResponse> | undefined, b: GetSnippetResponse | PlainMessage<GetSnippetResponse> | undefined): boolean {
    return proto3.util.equals(GetSnippetResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateSnippetRequest
 */
export class CreateSnippetRequest extends Message<CreateSnippetRequest> {
  /**
   * @generated from field: tracker.v1.TagManagerSnippet snippet = 1;
   */
  snippet?: TagManagerSnippet;

  constructor(data?: PartialMessage<CreateSnippetRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateSnippetRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "snippet", kind: "message", T: TagManagerSnippet },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSnippetRequest {
    return new CreateSnippetRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSnippetRequest {
    return new CreateSnippetRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSnippetRequest {
    return new CreateSnippetRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateSnippetRequest | PlainMessage<CreateSnippetRequest> | undefined, b: CreateSnippetRequest | PlainMessage<CreateSnippetRequest> | undefined): boolean {
    return proto3.util.equals(CreateSnippetRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateSnippetResponse
 */
export class CreateSnippetResponse extends Message<CreateSnippetResponse> {
  /**
   * @generated from field: tracker.v1.TagManagerSnippet snippet = 1;
   */
  snippet?: TagManagerSnippet;

  constructor(data?: PartialMessage<CreateSnippetResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateSnippetResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "snippet", kind: "message", T: TagManagerSnippet },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSnippetResponse {
    return new CreateSnippetResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSnippetResponse {
    return new CreateSnippetResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSnippetResponse {
    return new CreateSnippetResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateSnippetResponse | PlainMessage<CreateSnippetResponse> | undefined, b: CreateSnippetResponse | PlainMessage<CreateSnippetResponse> | undefined): boolean {
    return proto3.util.equals(CreateSnippetResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateSnippetRequest
 */
export class UpdateSnippetRequest extends Message<UpdateSnippetRequest> {
  /**
   * @generated from field: tracker.v1.TagManagerSnippet snippet = 1;
   */
  snippet?: TagManagerSnippet;

  constructor(data?: PartialMessage<UpdateSnippetRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateSnippetRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "snippet", kind: "message", T: TagManagerSnippet },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateSnippetRequest {
    return new UpdateSnippetRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateSnippetRequest {
    return new UpdateSnippetRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateSnippetRequest {
    return new UpdateSnippetRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateSnippetRequest | PlainMessage<UpdateSnippetRequest> | undefined, b: UpdateSnippetRequest | PlainMessage<UpdateSnippetRequest> | undefined): boolean {
    return proto3.util.equals(UpdateSnippetRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateSnippetResponse
 */
export class UpdateSnippetResponse extends Message<UpdateSnippetResponse> {
  /**
   * @generated from field: tracker.v1.TagManagerSnippet snippet = 1;
   */
  snippet?: TagManagerSnippet;

  constructor(data?: PartialMessage<UpdateSnippetResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateSnippetResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "snippet", kind: "message", T: TagManagerSnippet },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateSnippetResponse {
    return new UpdateSnippetResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateSnippetResponse {
    return new UpdateSnippetResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateSnippetResponse {
    return new UpdateSnippetResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateSnippetResponse | PlainMessage<UpdateSnippetResponse> | undefined, b: UpdateSnippetResponse | PlainMessage<UpdateSnippetResponse> | undefined): boolean {
    return proto3.util.equals(UpdateSnippetResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.DeleteSnippetRequest
 */
export class DeleteSnippetRequest extends Message<DeleteSnippetRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<DeleteSnippetRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DeleteSnippetRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteSnippetRequest {
    return new DeleteSnippetRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteSnippetRequest {
    return new DeleteSnippetRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteSnippetRequest {
    return new DeleteSnippetRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteSnippetRequest | PlainMessage<DeleteSnippetRequest> | undefined, b: DeleteSnippetRequest | PlainMessage<DeleteSnippetRequest> | undefined): boolean {
    return proto3.util.equals(DeleteSnippetRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.DeleteSnippetResponse
 */
export class DeleteSnippetResponse extends Message<DeleteSnippetResponse> {
  constructor(data?: PartialMessage<DeleteSnippetResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DeleteSnippetResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteSnippetResponse {
    return new DeleteSnippetResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteSnippetResponse {
    return new DeleteSnippetResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteSnippetResponse {
    return new DeleteSnippetResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteSnippetResponse | PlainMessage<DeleteSnippetResponse> | undefined, b: DeleteSnippetResponse | PlainMessage<DeleteSnippetResponse> | undefined): boolean {
    return proto3.util.equals(DeleteSnippetResponse, a, b);
  }
}

/**
 * PublishSnippet flips the snippet to PUBLISHED, bumps `version`, and
 * captures a version row.
 *
 * @generated from message tracker.v1.PublishSnippetRequest
 */
export class PublishSnippetRequest extends Message<PublishSnippetRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * human-readable "why" stored on the version row
   *
   * @generated from field: string note = 2;
   */
  note = "";

  constructor(data?: PartialMessage<PublishSnippetRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.PublishSnippetRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PublishSnippetRequest {
    return new PublishSnippetRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PublishSnippetRequest {
    return new PublishSnippetRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PublishSnippetRequest {
    return new PublishSnippetRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PublishSnippetRequest | PlainMessage<PublishSnippetRequest> | undefined, b: PublishSnippetRequest | PlainMessage<PublishSnippetRequest> | undefined): boolean {
    return proto3.util.equals(PublishSnippetRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.PublishSnippetResponse
 */
export class PublishSnippetResponse extends Message<PublishSnippetResponse> {
  /**
   * @generated from field: tracker.v1.TagManagerSnippet snippet = 1;
   */
  snippet?: TagManagerSnippet;

  constructor(data?: PartialMessage<PublishSnippetResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.PublishSnippetResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "snippet", kind: "message", T: TagManagerSnippet },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PublishSnippetResponse {
    return new PublishSnippetResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PublishSnippetResponse {
    return new PublishSnippetResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PublishSnippetResponse {
    return new PublishSnippetResponse().fromJsonString(jsonString, options);
  }

  static equals(a: PublishSnippetResponse | PlainMessage<PublishSnippetResponse> | undefined, b: PublishSnippetResponse | PlainMessage<PublishSnippetResponse> | undefined): boolean {
    return proto3.util.equals(PublishSnippetResponse, a, b);
  }
}

/**
 * ListVersions returns the version history of a snippet (newest first).
 *
 * @generated from message tracker.v1.ListVersionsRequest
 */
export class ListVersionsRequest extends Message<ListVersionsRequest> {
  /**
   * @generated from field: string snippet_id = 1;
   */
  snippetId = "";

  /**
   * @generated from field: tracker.v1.Pagination pagination = 2;
   */
  pagination?: Pagination;

  constructor(data?: PartialMessage<ListVersionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListVersionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "snippet_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "pagination", kind: "message", T: Pagination },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListVersionsRequest {
    return new ListVersionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListVersionsRequest {
    return new ListVersionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListVersionsRequest {
    return new ListVersionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListVersionsRequest | PlainMessage<ListVersionsRequest> | undefined, b: ListVersionsRequest | PlainMessage<ListVersionsRequest> | undefined): boolean {
    return proto3.util.equals(ListVersionsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListVersionsResponse
 */
export class ListVersionsResponse extends Message<ListVersionsResponse> {
  /**
   * @generated from field: repeated tracker.v1.TagManagerSnippetVersion items = 1;
   */
  items: TagManagerSnippetVersion[] = [];

  /**
   * @generated from field: tracker.v1.PaginationMeta pagination = 2;
   */
  pagination?: PaginationMeta;

  constructor(data?: PartialMessage<ListVersionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListVersionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: TagManagerSnippetVersion, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationMeta },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListVersionsResponse {
    return new ListVersionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListVersionsResponse {
    return new ListVersionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListVersionsResponse {
    return new ListVersionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListVersionsResponse | PlainMessage<ListVersionsResponse> | undefined, b: ListVersionsResponse | PlainMessage<ListVersionsResponse> | undefined): boolean {
    return proto3.util.equals(ListVersionsResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.TagManagerSnippetVersion
 */
export class TagManagerSnippetVersion extends Message<TagManagerSnippetVersion> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string snippet_id = 2;
   */
  snippetId = "";

  /**
   * @generated from field: int32 version = 3;
   */
  version = 0;

  /**
   * snapshot_json is the JSON-marshalled snippet at publish time. The FE
   * diff view parses this client-side; the BE never reconstructs the
   * snapshot into the live row except via RollbackSnippet.
   *
   * @generated from field: string snapshot_json = 4;
   */
  snapshotJson = "";

  /**
   * @generated from field: string note = 5;
   */
  note = "";

  /**
   * @generated from field: string published_by = 6;
   */
  publishedBy = "";

  /**
   * @generated from field: string published_at = 7;
   */
  publishedAt = "";

  constructor(data?: PartialMessage<TagManagerSnippetVersion>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.TagManagerSnippetVersion";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "snippet_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "snapshot_json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "published_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "published_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TagManagerSnippetVersion {
    return new TagManagerSnippetVersion().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TagManagerSnippetVersion {
    return new TagManagerSnippetVersion().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TagManagerSnippetVersion {
    return new TagManagerSnippetVersion().fromJsonString(jsonString, options);
  }

  static equals(a: TagManagerSnippetVersion | PlainMessage<TagManagerSnippetVersion> | undefined, b: TagManagerSnippetVersion | PlainMessage<TagManagerSnippetVersion> | undefined): boolean {
    return proto3.util.equals(TagManagerSnippetVersion, a, b);
  }
}

/**
 * RollbackSnippet restores `target_version`'s snapshot into the live row.
 * The current state is captured as a fresh version before the rollback
 * applies so the operation is itself undoable.
 *
 * @generated from message tracker.v1.RollbackSnippetRequest
 */
export class RollbackSnippetRequest extends Message<RollbackSnippetRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: int32 target_version = 2;
   */
  targetVersion = 0;

  /**
   * @generated from field: string note = 3;
   */
  note = "";

  constructor(data?: PartialMessage<RollbackSnippetRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.RollbackSnippetRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "target_version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RollbackSnippetRequest {
    return new RollbackSnippetRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RollbackSnippetRequest {
    return new RollbackSnippetRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RollbackSnippetRequest {
    return new RollbackSnippetRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RollbackSnippetRequest | PlainMessage<RollbackSnippetRequest> | undefined, b: RollbackSnippetRequest | PlainMessage<RollbackSnippetRequest> | undefined): boolean {
    return proto3.util.equals(RollbackSnippetRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.RollbackSnippetResponse
 */
export class RollbackSnippetResponse extends Message<RollbackSnippetResponse> {
  /**
   * @generated from field: tracker.v1.TagManagerSnippet snippet = 1;
   */
  snippet?: TagManagerSnippet;

  constructor(data?: PartialMessage<RollbackSnippetResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.RollbackSnippetResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "snippet", kind: "message", T: TagManagerSnippet },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RollbackSnippetResponse {
    return new RollbackSnippetResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RollbackSnippetResponse {
    return new RollbackSnippetResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RollbackSnippetResponse {
    return new RollbackSnippetResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RollbackSnippetResponse | PlainMessage<RollbackSnippetResponse> | undefined, b: RollbackSnippetResponse | PlainMessage<RollbackSnippetResponse> | undefined): boolean {
    return proto3.util.equals(RollbackSnippetResponse, a, b);
  }
}

/**
 * DebugFire runs the firing engine against a draft snippet (or an existing
 * row) using a caller-supplied simulated request context. Used by the
 * preview modal in the FE; never persists anything.
 *
 * @generated from message tracker.v1.DebugFireRequest
 */
export class DebugFireRequest extends Message<DebugFireRequest> {
  /**
   * Either snippet_id (refers to a persisted row) or snippet (a fresh
   * draft) must be supplied. snippet wins when both are present.
   *
   * @generated from field: string snippet_id = 1;
   */
  snippetId = "";

  /**
   * @generated from field: tracker.v1.TagManagerSnippet snippet = 2;
   */
  snippet?: TagManagerSnippet;

  /**
   * Simulated request context.
   *
   * @generated from field: string country_code = 3;
   */
  countryCode = "";

  /**
   * @generated from field: string language = 4;
   */
  language = "";

  /**
   * @generated from field: string user_agent = 5;
   */
  userAgent = "";

  /**
   * @generated from field: map<string, string> headers = 6;
   */
  headers: { [key: string]: string } = {};

  /**
   * @generated from field: map<string, string> url_params = 7;
   */
  urlParams: { [key: string]: string } = {};

  /**
   * @generated from field: map<string, string> consent_state = 8;
   */
  consentState: { [key: string]: string } = {};

  constructor(data?: PartialMessage<DebugFireRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DebugFireRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "snippet_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "snippet", kind: "message", T: TagManagerSnippet },
    { no: 3, name: "country_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "user_agent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "headers", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 7, name: "url_params", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 8, name: "consent_state", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DebugFireRequest {
    return new DebugFireRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DebugFireRequest {
    return new DebugFireRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DebugFireRequest {
    return new DebugFireRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DebugFireRequest | PlainMessage<DebugFireRequest> | undefined, b: DebugFireRequest | PlainMessage<DebugFireRequest> | undefined): boolean {
    return proto3.util.equals(DebugFireRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.DebugFireResponse
 */
export class DebugFireResponse extends Message<DebugFireResponse> {
  /**
   * @generated from field: repeated tracker.v1.FiredSnippet fired = 1;
   */
  fired: FiredSnippet[] = [];

  /**
   * @generated from field: repeated tracker.v1.DebugFireRejection rejected = 2;
   */
  rejected: DebugFireRejection[] = [];

  constructor(data?: PartialMessage<DebugFireResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DebugFireResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "fired", kind: "message", T: FiredSnippet, repeated: true },
    { no: 2, name: "rejected", kind: "message", T: DebugFireRejection, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DebugFireResponse {
    return new DebugFireResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DebugFireResponse {
    return new DebugFireResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DebugFireResponse {
    return new DebugFireResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DebugFireResponse | PlainMessage<DebugFireResponse> | undefined, b: DebugFireResponse | PlainMessage<DebugFireResponse> | undefined): boolean {
    return proto3.util.equals(DebugFireResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.FiredSnippet
 */
export class FiredSnippet extends Message<FiredSnippet> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: tracker.v1.TagManagerSnippetKind kind = 3;
   */
  kind = TagManagerSnippetKind.UNSPECIFIED;

  /**
   * @generated from field: tracker.v1.TagManagerPlacement placement = 4;
   */
  placement = TagManagerPlacement.UNSPECIFIED;

  /**
   * @generated from field: string code = 5;
   */
  code = "";

  constructor(data?: PartialMessage<FiredSnippet>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.FiredSnippet";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "kind", kind: "enum", T: proto3.getEnumType(TagManagerSnippetKind) },
    { no: 4, name: "placement", kind: "enum", T: proto3.getEnumType(TagManagerPlacement) },
    { no: 5, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FiredSnippet {
    return new FiredSnippet().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FiredSnippet {
    return new FiredSnippet().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FiredSnippet {
    return new FiredSnippet().fromJsonString(jsonString, options);
  }

  static equals(a: FiredSnippet | PlainMessage<FiredSnippet> | undefined, b: FiredSnippet | PlainMessage<FiredSnippet> | undefined): boolean {
    return proto3.util.equals(FiredSnippet, a, b);
  }
}

/**
 * @generated from message tracker.v1.DebugFireRejection
 */
export class DebugFireRejection extends Message<DebugFireRejection> {
  /**
   * @generated from field: string snippet_id = 1;
   */
  snippetId = "";

  /**
   * @generated from field: string snippet_name = 2;
   */
  snippetName = "";

  /**
   * reason ∈ {disabled, condition_miss, condition_missing_ctx, consent_blocked, status_not_published}
   *
   * @generated from field: string reason = 3;
   */
  reason = "";

  /**
   * missing_consent is populated for reason=consent_blocked.
   *
   * @generated from field: repeated string missing_consent = 4;
   */
  missingConsent: string[] = [];

  constructor(data?: PartialMessage<DebugFireRejection>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DebugFireRejection";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "snippet_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "snippet_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "missing_consent", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DebugFireRejection {
    return new DebugFireRejection().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DebugFireRejection {
    return new DebugFireRejection().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DebugFireRejection {
    return new DebugFireRejection().fromJsonString(jsonString, options);
  }

  static equals(a: DebugFireRejection | PlainMessage<DebugFireRejection> | undefined, b: DebugFireRejection | PlainMessage<DebugFireRejection> | undefined): boolean {
    return proto3.util.equals(DebugFireRejection, a, b);
  }
}

/**
 * TestFireDestination dispatches a stub event against the configured
 * destination so authors can confirm field mappings + secret refs without
 * polluting production analytics.
 *
 * @generated from message tracker.v1.TestFireDestinationRequest
 */
export class TestFireDestinationRequest extends Message<TestFireDestinationRequest> {
  /**
   * @generated from field: string snippet_id = 1;
   */
  snippetId = "";

  /**
   * draft variant, like DebugFireRequest
   *
   * @generated from field: tracker.v1.TagManagerSnippet snippet = 2;
   */
  snippet?: TagManagerSnippet;

  /**
   * field name → value
   *
   * @generated from field: map<string, string> simulated_event = 3;
   */
  simulatedEvent: { [key: string]: string } = {};

  constructor(data?: PartialMessage<TestFireDestinationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.TestFireDestinationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "snippet_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "snippet", kind: "message", T: TagManagerSnippet },
    { no: 3, name: "simulated_event", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TestFireDestinationRequest {
    return new TestFireDestinationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TestFireDestinationRequest {
    return new TestFireDestinationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TestFireDestinationRequest {
    return new TestFireDestinationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: TestFireDestinationRequest | PlainMessage<TestFireDestinationRequest> | undefined, b: TestFireDestinationRequest | PlainMessage<TestFireDestinationRequest> | undefined): boolean {
    return proto3.util.equals(TestFireDestinationRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.TestFireDestinationResponse
 */
export class TestFireDestinationResponse extends Message<TestFireDestinationResponse> {
  /**
   * @generated from field: bool ok = 1;
   */
  ok = false;

  /**
   * @generated from field: string detail = 2;
   */
  detail = "";

  /**
   * @generated from field: int32 http_status = 3;
   */
  httpStatus = 0;

  /**
   * @generated from field: string response_body = 4;
   */
  responseBody = "";

  constructor(data?: PartialMessage<TestFireDestinationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.TestFireDestinationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ok", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "detail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "http_status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "response_body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TestFireDestinationResponse {
    return new TestFireDestinationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TestFireDestinationResponse {
    return new TestFireDestinationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TestFireDestinationResponse {
    return new TestFireDestinationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: TestFireDestinationResponse | PlainMessage<TestFireDestinationResponse> | undefined, b: TestFireDestinationResponse | PlainMessage<TestFireDestinationResponse> | undefined): boolean {
    return proto3.util.equals(TestFireDestinationResponse, a, b);
  }
}

